<svelte:options tag={null} />
  <script>
  export let id = undefined;
  export let style = undefined;
  export let className = undefined;
  export let fill = undefined;
  export let size = "2rem";
</script>

<svg aria-hidden="true" width={size} height={size} id={id}  style={style} class={className} fill={fill} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32"><path d="M27 19.26v-8.48a2 2 0 00-.94-1.7l-9-5.6a2 2 0 00-2.12 0l-9 5.6a2 2 0 00-.94 1.7v10.44a2 2 0 00.94 1.7l9 5.6a2 2 0 002.12 0l2.29-1.43A5.49 5.49 0 1027 19.26zM16 5.18l8.11 5.05L21.27 12l-8.11-5zm0 10.1l-8.11-5 3.38-2.11 8.11 5.05zm-9 5.94V12l8 5v9.2zm10 5V17l8-5v6.18a5.72 5.72 0 00-1.5-.18 5.49 5.49 0 00-5.17 7.37zm6.5.8A3.5 3.5 0 1127 23.5a3.5 3.5 0 01-3.5 3.5z"/><path d="M24.5 21h-2v1.5H21v2h1.5V26h2v-1.5H26v-2h-1.5V21z"/></svg>